import api from '../service/api.service';

import {
  PayoutWorklistDetailResponse,
  PayoutWorklistQueryParams,
  PayoutWorklistResponse,
} from '../../views/PayoutsView/types';

const BASE_URL = 'v1/fo/payouts/worklist';

export const getPayoutsWorklist = async (params: PayoutWorklistQueryParams) => {
  return await api.get<PayoutWorklistResponse>(BASE_URL, { params });
};

export const getPayoutWorklistDetails = async (settlementId: number, settlementSequenceId?: number) => {
  return await api.get<PayoutWorklistDetailResponse>(`${BASE_URL}/${settlementId}`, {
    params: settlementSequenceId ? { settlementSequenceId } : undefined,
  });
};

export const exportPayoutsWorklist = async (params: PayoutWorklistQueryParams) => {
  return await api.get<PayoutWorklistResponse>(`${BASE_URL}/export`, {
    params,
  });
};
